export const DRAWER_TYPE_CONTACT_USER_SEARCH = 'user'
export const DRAWER_TYPE_USER_PROVIDER_SEARCH = 'provider'
